import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ConfigProvider } from 'antd-v6';
import EnUS from 'antd-v6/locale/en_US';
import EsES from 'antd-v6/locale/es_ES';
import Root from '../../components/Root';
import { locale } from '../../constants/global';
import { FetchLanguage } from '../languages/actions';
import unitSystem from '../unitSystems';

const Language = () => {
	const lang = useSelector((state) =>
		state.language.language ? state.language.language : state.language.defaultLanguage
	);
	const user = useSelector((state) => state.auth.user);
	const dispatch = useDispatch();

	useEffect(() => {
		if (user.unitSystemConfig) unitSystem.setConfigurations(JSON.parse(user.unitSystemConfig));
		if (user.languageId === 2) dispatch(FetchLanguage('es_ES'));
	}, [user]);

	return (
		<ConfigProvider locale={lang === 'en_US' ? EnUS : EsES}>
			<Root locale={locale} lang={lang} />
		</ConfigProvider>
	);
};

export default Language;
